import { Route, Routes, Outlet } from "react-router-dom";
import React from "react";
import AdminLayout from "../layout/AdminLayout";
import PublicLayout from "../layout/PublicLayout";
import AdminRoutes from "./AdminRoutes";
import AccountLogin from "../pages/accounts/login";
import AccountSignUp from "../pages/accounts/signup";
import AccountForgetPin from "../pages/accounts/forgot-pin";
import TermsPrivacy from "../pages/legal/terms-privacy";
import Help from "../pages/legal/help";


const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<AccountLogin />}></Route>
      <Route path="/login" element={<AccountLogin />}></Route>
      <Route path="/signup" element={<AccountSignUp />}></Route>
      <Route path="/forget-pin" element={<AccountForgetPin />}></Route>
      <Route path="/terms-privacy" element={<PublicLayout component={<TermsPrivacy />} />}></Route>
      <Route path="/help" element={<PublicLayout component={<Help />} />}></Route>
      <Route path="" element={<Outlet />}>
        {AdminRoutes.map((element) => {
          return (
            <Route
              key={element}
              path={element.path}
              element={<AdminLayout component={element.component} />}
            />
          );
        })}
      </Route>
      <Route path="/login" element={<AccountLogin />}></Route>
    </Routes>
  );
};

export default React.memo(Router);
